module.exports = __webpack_public_path__ + "static/media/min.5c875807.svg";